import { createTopic, editTopic, ForumCtaEnum } from '@/app/models/forum/forum-cta'
import { ForumTypeEnum } from '@/app/models/forum/new-forum.model'
import { CtaGroupWrapper } from '../UI/CtaGroup/CtaGroupWrapper'

interface ForumTopicCtaProps {
    type?: ForumTypeEnum
    disabled?: boolean
    onCta: (action: string) => void
}

const ForumTopicCta = ({ type, disabled, onCta }: ForumTopicCtaProps) => {
    const ctaConfig = !type
        ? createTopic().setDisableConditions([
              {
                  action: ForumCtaEnum.CREATE_TOPIC,
                  disableCondition: disabled,
              }
          ])
        : editTopic()
    return <CtaGroupWrapper ctaConfig={ctaConfig} ctaHandler={onCta} />
}

export default ForumTopicCta
